var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
/* eslint-disable @rushstack/security/no-unsafe-regexp */
/* eslint-disable no-constant-condition */
import React, { useContext, useEffect, useState } from 'react';
import { Absolute, Avatar, Box, ChatMessage, Flex, Text } from 'pcln-design-system';
import { format } from 'date-fns';
import { VoteType } from './chatTypes';
import { ChatbotDataContext } from './context/ChatbotDataContext';
import { livePersonMessagesStatusManager } from './LivePersonService/livePersonMessageStatusManager';
import { TravelBotLogoImage } from './TravelBotLogoImage';
import VoteUp from './Assets/VoteUp';
import VoteDown from './Assets/VoteDown';
import styled from 'styled-components';
import { feedbackPost } from './utils/feedbackPost';
import analytics from './analytics';
import { motion } from 'framer-motion';
import { marked } from 'marked';
const COSTUMER_SUPPORT_NUMBER = '1-877-477-5807';
const GREETING_MESSAGE = "Hi, I'm Penny, your virtual travel assistant! How can I help you today?";
const VoteWrapper = /*#__PURE__*/styled(Box).withConfig({
  displayName: "TravelBotChatSingleDialogGeneric__VoteWrapper",
  componentId: "sc-56v0uk-0"
})(["cursor:pointer;"]);
const CustomChatMessage = /*#__PURE__*/styled(ChatMessage).withConfig({
  displayName: "TravelBotChatSingleDialogGeneric__CustomChatMessage",
  componentId: "sc-56v0uk-1"
})(["overflow-wrap:anywhere;& div:nth-child(2){width:fit-content;}"]);
const ChatMessageWrapper = /*#__PURE__*/styled(Box).withConfig({
  displayName: "TravelBotChatSingleDialogGeneric__ChatMessageWrapper",
  componentId: "sc-56v0uk-2"
})(["p{margin-block-start:0;margin-block-end:0;margin-inline-start:0;margin-inline-end:0;margin-bottom:8px;}p:last-child{margin-bottom:0;}"]);
/**
 * TravelBotChatSingleDialogGeneric
 * Support showing message content for assistan/user
 * @public
 */
export const TravelBotChatSingleDialogGeneric = props => {
  var _a;
  const {
    logCustomerCarePhoneNumberClicked,
    logCustomerCarePhoneNumberDisplayed,
    isMobile,
    submitChatMessagesPayload,
    fetchRequestOptions
  } = useContext(ChatbotDataContext);
  const {
    message,
    livePersonAgentInitial,
    livePersonAgentName
  } = props;
  const {
    rguid,
    cguid
  } = submitChatMessagesPayload !== null && submitChatMessagesPayload !== void 0 ? submitChatMessagesPayload : {};
  const {
    content,
    role,
    vote = VoteType.NONE
  } = message;
  const [voteStatus, setVoteStatus] = useState(vote);
  const [voteSubmitted, setVoteSubmitted] = useState(false);
  const isAssistant = role === 'assistant';
  const isLivePersonAgent = role === 'livePersonAgent';
  const isNotUser = isAssistant || isLivePersonAgent;
  function phoneNumberClicked() {
    if (logCustomerCarePhoneNumberClicked && typeof logCustomerCarePhoneNumberClicked === 'function') {
      logCustomerCarePhoneNumberClicked();
    }
  }
  useEffect(() => {
    window.phoneNumberClicked = phoneNumberClicked;
    return () => {
      window.phoneNumberClicked = null;
    };
  }, []);
  const MessageIcon = function Icon(props) {
    if (isAssistant) {
      return React.createElement(TravelBotLogoImage, null);
    }
    if (isLivePersonAgent) {
      return React.createElement(Avatar, Object.assign({}, props, {
        initials: livePersonAgentInitial,
        color: 'primary'
      }));
    }
    return null;
  };
  const footerMessagePrefix = isAssistant ? 'Penny' : isLivePersonAgent ? livePersonAgentName ? ((_a = livePersonAgentName === null || livePersonAgentName === void 0 ? void 0 : livePersonAgentName.split(' ')) === null || _a === void 0 ? void 0 : _a[0]) || livePersonAgentInitial : 'Agent' : '';
  const transformedDate = (message === null || message === void 0 ? void 0 : message.date) ? new Date(message.date).valueOf() : undefined;
  const footerMessageDateString = transformedDate && typeof transformedDate === 'number' ? format(message === null || message === void 0 ? void 0 : message.date, "LLL d 'at' h:mm:ss aaa") : '';
  const messgeStatus = livePersonMessagesStatusManager.getStatusByMsgId(message.msgId);
  const handleVoteStatus = status => {
    setVoteStatus(status);
  };
  const handleFeedbackSubmit = (vote, feedback) => __awaiter(void 0, void 0, void 0, function* () {
    try {
      if (!voteSubmitted) {
        const {
          headers
        } = fetchRequestOptions;
        const baseUrl = '/genai-svc/genai/chat/feedback';
        yield feedbackPost({
          feedback: feedback !== null && feedback !== void 0 ? feedback : '',
          message: Object.assign(Object.assign({}, props.message), {
            vote
          }),
          conversationId: rguid,
          cguid
        }, baseUrl, headers);
        setVoteSubmitted(true);
      }
    } catch (e) {
      analytics.log({
        source: 'feedback error',
        message: e,
        cguid,
        conversationId: rguid
      });
    }
  });
  const showVoteUp = voteStatus === VoteType.NONE || voteStatus === VoteType.UP;
  const showVoteDown = voteStatus === VoteType.NONE || voteStatus === VoteType.DOWN;
  const isGreetingMessage = GREETING_MESSAGE === message.content;
  const voteGap = isMobile ? 4 : 3;
  const Footer = footerMessageDateString ? React.createElement(motion.div, {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    }
  }, React.createElement(Flex, {
    alignItems: 'center',
    justifyContent: isNotUser ? 'space-between' : 'flex-end'
  }, messgeStatus && React.createElement(Text, {
    color: 'text.light',
    textStyle: 'subheading6',
    mr: 2
  }, messgeStatus), footerMessagePrefix && React.createElement(Absolute, {
    width: 0.96,
    top: '-10px'
  }, React.createElement(Flex, {
    justifyContent: 'space-between',
    width: 1
  }, React.createElement(Text, {
    color: 'text.light',
    textStyle: 'subheading6'
  }, footerMessagePrefix, " \u00B7 ", footerMessageDateString), !isGreetingMessage ? React.createElement(Flex, null, showVoteUp ? React.createElement(VoteWrapper, {
    mr: showVoteUp && !showVoteDown ? 0 : voteGap,
    onClick: function () {
      return __awaiter(this, void 0, void 0, function* () {
        handleVoteStatus(VoteType.UP);
        yield handleFeedbackSubmit(VoteType.UP, '');
      });
    }
  }, React.createElement(VoteUp, {
    isActive: voteStatus === VoteType.UP
  })) : null, showVoteDown ? React.createElement(VoteWrapper, {
    onClick: function () {
      return __awaiter(this, void 0, void 0, function* () {
        handleVoteStatus(VoteType.DOWN);
        yield handleFeedbackSubmit(VoteType.DOWN, '');
      });
    }
  }, React.createElement(VoteDown, {
    isActive: voteStatus === VoteType.DOWN
  })) : null) : null)), !footerMessagePrefix && React.createElement(Text, {
    color: 'text.light',
    textStyle: 'subheading6'
  }, footerMessageDateString))) : null;
  function getMarkdownText(text) {
    const rawMarkup = marked.parse(text);
    return {
      __html: rawMarkup
    };
  }
  function convertToTelLink(phoneNumber) {
    if (phoneNumber === COSTUMER_SUPPORT_NUMBER && logCustomerCarePhoneNumberDisplayed && typeof logCustomerCarePhoneNumberDisplayed === 'function') {
      logCustomerCarePhoneNumberDisplayed();
    }
    const cleanNumber = phoneNumber.replace(/\D/g, '');
    return phoneNumber === COSTUMER_SUPPORT_NUMBER ? `<a href="tel:${cleanNumber}" onclick="window.phoneNumberClicked()" >${phoneNumber}</a>` : `<a href="tel:${cleanNumber}">${phoneNumber}</a>`;
  }
  return React.createElement(CustomChatMessage, {
    mb: isNotUser ? '40px' : 4,
    ml: isNotUser ? '' : 'auto',
    variation: isNotUser ? 'initial' : 'outgoing',
    Icon: MessageIcon,
    message: React.createElement(Text, {
      fontSize: 2
    }, React.createElement(Text, {
      fontSize: 2
    }, React.createElement(ChatMessageWrapper, null, React.createElement("div", {
      dangerouslySetInnerHTML: getMarkdownText(content.replace(/(\d[\d-. ]+\d)/g, convertToTelLink))
    })))),
    footer: Footer
  });
};